import installer from "./defaults";

export * from "@bvite/components";

export * as makeInstaller from "./make-installer";

export const install = installer.install;

export { default } from "./defaults";
